import { Line } from '@react-three/drei';
import * as THREE from 'three';
import ProductClearanceLabel from './ProductClearanceLabel';
import { useNavigation } from '../../function/navigation';
import { UnitConversion } from '../../inputs/UnitConversion';

function HeightDifference({
  inputs,
  result,
  convRatio,
  drawingBaseDimensions,
}) {
  const { nav } = useNavigation();
  const d = drawingBaseDimensions;
  const h1 = d.h1 * convRatio;
  const h2 = d.h2 * convRatio;
  const h3 = d.h3 * convRatio;

  const isReverse = ['A', 'C', 'E', 'G', 'L'].includes(d.configuration);
  const reverseMultiplier = isReverse ? 1 : -1;
  const configurationAngleRadians = THREE.MathUtils.degToRad(
    isReverse ? d.configuration_angle : 360 - d.configuration_angle
  );

  const z = ((1.2 * d.footprint_diameter) / 2) * convRatio;
  const textSize = 16;

  const renderLabel = (length, color) => (
    <Line
      points={[
        [0, -length / 2, 0],
        [0, length / 2, 0],
      ].filter(Boolean)}
      color={color}
      lineWidth={3}
    />
  );

  const { displayedValue: displayedh1 } = UnitConversion(
    inputs.h1,
    inputs.unit_system,
    'mm'
  );

  const { displayedValue: displayedh2 } = UnitConversion(
    inputs.h2 || result.h2,
    inputs.unit_system,
    'mm'
  );

  const { displayedValue: displayedh3 } = UnitConversion(
    inputs.h3 || result.h3,
    inputs.unit_system,
    'mm'
  );

  return (
    <>
      <group
        position={[
          (d.central_diam / 2) * convRatio,
          h1 / 2,
          -z * reverseMultiplier,
        ]}
      >
        {renderLabel(h1, 'SeaGreen')}
        <ProductClearanceLabel
          value={displayedh1}
          reverseConfig={-1}
          textSize={textSize}
          color="SeaGreen"
          focus={nav.focusedInput === 'h1'}
        />
      </group>
      <group
        position={[
          (d.central_diam / 2) * convRatio,
          h1 + h2 / 2,
          -z * reverseMultiplier,
        ]}
      >
        {renderLabel(h2, 'DarkViolet')}
        <ProductClearanceLabel
          value={displayedh2 || ''}
          reverseConfig={-1}
          textSize={textSize}
          color="DarkViolet"
          focus={nav.focusedInput === 'h2'}
        />
      </group>
      <group rotation={[0, -configurationAngleRadians, 0]} position={[0, 0, 0]}>
        <group
          position={[
            (d.central_diam / 2) * convRatio,
            h3 / 2,
            z * reverseMultiplier,
          ]}
        >
          {renderLabel(h3, 'OrangeRed')}
          <ProductClearanceLabel
            value={displayedh3 || ''}
            reverseConfig={-1}
            textSize={textSize}
            color="OrangeRed"
            focus={nav.focusedInput === 'h3'}
          />
        </group>
      </group>
    </>
  );
}

export default HeightDifference;
